import { Button, Form } from 'antd';
import { FC } from 'react';

type SubmitButtonProps = {
	text: string;
	loading?: boolean;
	disabled?: boolean;
	className?: string;
	classNameWrapper?: string;
};

export const SubmitButton: FC<SubmitButtonProps> = ({
	text,
	loading,
	disabled,
	className,
	classNameWrapper,
}) => {
	return (
		<Form.Item className={classNameWrapper}>
			<Button
				className={className}
				type="primary"
				block
				size="large"
				htmlType="submit"
				loading={loading}
				disabled={disabled}
			>
				{text}
			</Button>
		</Form.Item>
	);
};
